module.exports = __webpack_public_path__ + "static/media/service_address_2-1.cd2aed85.png";